import React from "react";
import { SelectInputComponent } from "../../../../../common/components";
import { RATING_OPTIONS } from "../../../../../constants/leadDropdown";
import "./filter-options-select.scss"
interface ConfidenceScoreFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  isConfidenceScoreEnabled?: boolean;
  confidenceScoreError?: any;
}

const ConfidenceScoreFilter: React.FC<ConfidenceScoreFilterProps> = ({
  value,
  onChange,
  isConfidenceScoreEnabled,
  confidenceScoreError
}) => {
  if (!isConfidenceScoreEnabled) return null;


  return (
    <div className="filter-select-input-wrapper" >
      <SelectInputComponent
        fieldName="confidenceScore"
        options={RATING_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Confidence Score"
        multiple={true}
        colorProp={true}
        isFilter={true}
      />
      {confidenceScoreError && <div className="error-text">{confidenceScoreError}</div>}
    </div>
  );
};

export default ConfidenceScoreFilter;
